module.exports = __webpack_public_path__ + "img/outlook.9226cf08.png";